<div
  *ngIf="device === 'mobile' || device === 'tablet'"
  class="page-container"
  [ngStyle]="{ 'overflow-y': bodyScrollingOn ? 'scroll' : 'hidden' }"
>
  <finxone-web-frontend-mobile-container
    *ngIf="device === 'mobile' || device === 'tablet'"
    [zoneUrlInput]="zoneUrlName"
    [pageUrlInput]="pageUrlName"
    [isModal]="isModal"
    [navDirection]="navDirection"
  >
  </finxone-web-frontend-mobile-container>
</div>
<finxone-web-frontend-desktop-container
  *ngIf="device === 'desktop'"
  [zoneUrlInput]="zoneUrlName"
  [pageUrlInput]="pageUrlName"
  [menuType]="menuTypeForDesktop"
  [parentComponent]="'ParentContainerComponent'"
  [navDirection]="navDirection"
>
</finxone-web-frontend-desktop-container>
<!-- Named outlet for modal -->
<router-outlet name="modal"></router-outlet>
